import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Output, Input, EventEmitter } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { UserTypeManagerService, UserType } from "../services/usertype/user-type-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import { environment } from '../../../environments/environment';
import { LogService } from "../services/log/log.service";

import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";



declare var GGBApplet;

@Component({
    selector: "dskl-wb-geogebra",
    templateUrl: 'geogebra.component.html',
    inputs: ["board"],
    outputs: ["change", "onCurrentState"]
})

export class GeogebraWbComponent extends WhiteBoardComponent {


    constructor(protected log: LogService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, private userTypeManager: UserTypeManagerService, protected layoutService: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
        super(log, wbService, sessionManager, layoutService, permissionsManager);
        console.log(".. constructing geogebra")
    }

    pageName = "GEOGEBRA"
    applet;
    appletObject;

    onState(state, pageId) {
        if (pageId != this.board.pageId) {
            console.log("Not for me " + this.board.pageId + " but for " + pageId);
            console.log(state);
            return;
        }
        this.applet.getAppletObject().setBase64(state.data)
    }
    onResize() {

    }

    onReady() {

    }

    getWbType() {
        return this.pageName;
    }

    onViewReady() {
        this.applet = new GGBApplet('5.0', this.parameters)
        this.applet.setHTML5Codebase('assets/geogebra/HTML5/5.0/web3d/');
        this.applet.inject('applet_container1');
        this.registerEventListeners()
    }

    registerEventListeners() {

        setTimeout(x => {
            this.appletObject = this.applet.getAppletObject();
            console.log("regisering listeners", this.appletObject)
            this.appletObject.registerAddListener("addListener");
            this.appletObject.registerRemoveListener("removeListener");
            this.appletObject.registerRenameListener("renameListener");
            this.appletObject.registerClearListener("clearListener");
            this.appletObject.registerUpdateListener("updateListener");
        }, 3000)

    }

    addListener(objName) {
        console.log("add: " + objName);

    }

    removeListener(objName) {
        console.log("remove: " + objName);
    }

    renameListener(oldObjName, newObjName) {
        console.log("rename: " + oldObjName + "to " + newObjName);
    }

    updateListener(objName) {
        console.log("update: " + objName);
    }

    clearListener() {
        console.log('cleared')
    }

    getCurrentState() {
        console.log("geogebra getCurrentState")
        let state = { data: this.applet.getAppletObject().getBase64() }
        return state
    }

    onCurrentPageState(received) {
        console.log("geogebra onCurrentPageState")
        this.applet.getAppletObject().setBase64(received.data)
    }

    parameters = {

        "width": 1200,
        "height": 620,
        "showToolBar": true,
        "showMenuBar": true,
        // "showAlgebraInput":false,
        "showResetIcon": true,
        // "enableLabelDrags":true,
        // "enableShiftDragZoom":true,
        // "enableRightClick":true,
        // "showToolBarHelp":true,
        // "errorDialogsActive":true,
        "useBrowserForJS": true,
        "ggbOnInitParam": "initDone"
    }

     ggbOnInit(param){
alert('works')

        }

    /* "ggbBase64":"here comes your Ctrl-Shft-B string"}; */

    /* is3D=is 3D applet using 3D view, AV=Algebra View, SV=Spreadsheet View, CV=CAS View, EV2=Graphics View 2, CP=Construction Protocol, PC=Probability Calculator, DA=Data Analysis, FI=Function Inspector, PV=Python, macro=Macro View */

    //views = {"is3D":false,"AV":true,"SV":false,"CV":true,"EV2":false,"CP":false,"PC":false,"DA":false,"FI":false,"PV":false,"macro":false};

    // var applet = new GGBApplet('5.0', parameters, views);applet.setJavaCodebaseVersion('5.0');applet.setHTML5CodebaseVersion('5.0');applet.setHTML5Codebase('http://www.geogebra.org/web/5.0/web/', true);applet.setJNLPFile('http://www.geogebratube.org/webstart/5.0/applet50_web.jnlp');

    // window.onload = function() { applet.inject('applet_container', 'preferHTML5'); }


    save() {
        this.emitChanged({ data: this.applet.getAppletObject().getBase64() })
    }


}



// WEBPACK FOOTER //
// /app/src/app/wb/geogebra/geogebra.component.ts